import { useContext, useMemo, useState } from "react";
import Footer from "../../../../components/footer";
import Notification from "../../../../components/toast";
import { ContextRegisterProduct } from "../context";
import TableProducts from "../table";
import FilterRegisterProduct from "../filter";
import { ToastContainer } from "react-toastify";
import ModalRegisterProduct from "../modal-register";
import ModalProductVariants from "../modal-variants";
import { ListFilter } from "../../../../components/list-filter";
import HeaderReport from "../../../../components/header/report";
import ModalMain from "../../../../components/modal";
import ReportModalContent from "../../../../components/report/ReportModalContent";

// Os relatórios genéricos (ReportModalContent/generateReport) esperam filtros no formato { chave: { label, value } }
const PARAM_LABELS = {
	nome: "Descrição",
	ean: "Ean",
	referencia: "Referência",
	categoria: "Categoria",
};

const TIPO_PRODUTO_LABELS = {
	pai: "Somente Pai",
	filho: "Somente Filhos",
	todos: "Todos",
};

const MainRegisterProduct = () => {
	const identForm = "product";
	const options = {
		title: "Cadastro de Produtos",
		subTitle: "Produtos",
		identReport: `report${identForm}`, //usado para definir os event listners
		reportColumns: [
			{ key: "nome", label: "Descrição", align: "left", visible: true },
			{ key: "ean", label: "EAN", align: "left", visible: true },
			{ key: "qtatual", label: "Qtd. Atual", align: "center", visible: true },
			{ key: "qtcritica", label: "Qtd. Crítica", align: "center", visible: true },
			{ key: "valor", label: "Valor", align: "right", format: "currency", visible: true },
			{ key: "markup", label: "Markup (%)", align: "center", visible: true },
			{ key: "custo", label: "Custo", align: "right", format: "currency", visible: true },
			{ key: "lucro", label: "Lucro", align: "right", format: "currency", visible: false },
			{ key: "rendimento", label: "Rendimento (%)", align: "center", visible: false },
			{ key: "und", label: "Unidade", align: "center", visible: false },
			{ key: "referencia", label: "Referência", align: "left", visible: false },
			{ key: "prod_promocao", label: "Promoção", align: "center", visible: false },
			{ key: "valorpromoapi", label: "Valor Promoção", align: "right", format: "currency", visible: false },
			{ key: "qtde", label: "Qtde", align: "center", visible: false },
			{ key: "comissao", label: "Comissão", align: "right", format: "currency", visible: false },
			{ key: "ativo", label: "Status", align: "left", format: "badgePgto", visible: false },
			{ key: "descmax", label: "Desc. Máx.", align: "right", format: "percent", visible: false },
		],
	};
	const { handleOpenModalRegister, handleOpenModalFilter, filterData, fetchAllProducts } =
		useContext(ContextRegisterProduct);

	const [reportData, setReportData] = useState([]);
	const [isLoadingReport, setIsLoadingReport] = useState(false);

	const reportFilters = useMemo(() => {
		if (!filterData || typeof filterData !== "object") return {};

		const filters = {};

		if (filterData.param) {
			filters.param = {
				label: PARAM_LABELS[filterData.param] || "Parâmetro",
				value: filterData.paramValue || "",
			};
		}

		if (filterData.tipoproduto) {
			filters.tipoproduto = {
				label: "Tipo de produto",
				value: TIPO_PRODUTO_LABELS[filterData.tipoproduto] || filterData.tipoproduto,
			};
		}

		if (filterData.ativo) {
			filters.ativo = {
				label: "Ativo",
				value: filterData.ativo,
			};
		}

		return filters;
	}, [filterData]);

	const handleOpenModalReport = async () => {
		try {
			setIsLoadingReport(true);
			const data = await fetchAllProducts(filterData);
			setReportData(data);

			const event = new CustomEvent(`${options.identReport}`);
			window.dispatchEvent(event);
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setIsLoadingReport(false);
		}
	};

	return (
		<div className="container-register">
			<header className="mt-page">
				<div className="grid grid-cols-2">
					<div className="col-span-1">
						<HeaderReport title={options.title} subTitle={options.subTitle} />
					</div>
					<div className="col-span-1 flex justify-end">
						<ListFilter filterData={filterData} />
					</div>
				</div>

				<ToastContainer />
				<FilterRegisterProduct />
				<ModalRegisterProduct />
				<ModalProductVariants />

				<div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
					<button className="min-w-40 btn btn-sm btn-success w-15" onClick={(e) => handleOpenModalRegister()}>
						{options.title}
					</button>
					<div className="flex gap-2 flex-wrap ">
						<button
							className="min-w-40 btn btn-sm btn-primary w-25"
							onClick={(e) => handleOpenModalFilter(e)}
						>
							Listar
						</button>
						{options.reportColumns && (
							<button
								className="min-w-40 btn btn-sm btn-danger"
								onClick={handleOpenModalReport}
								disabled={isLoadingReport}
							>
								{isLoadingReport ? "Carregando..." : "Relatório"}
							</button>
						)}
					</div>
				</div>
				{/* <div className="d-flex justify-content-between align-items-center">
					<button className="btn btn-sm btn-success w-15" onClick={(e) => handleOpenModalRegister()}>
						Cadastrar produto
					</button>
					<button className="btn btn-sm btn-primary w-25" onClick={(e) => handleOpenModalFilter()}>
						Listar
					</button>
				</div> */}
			</header>
			<main>
				<TableProducts />
			</main>
			<footer>
				<Footer />
			</footer>
			<ModalMain ident={options.identReport}>
				<ReportModalContent
					reportColumns={options.reportColumns}
					data={reportData}
					filters={reportFilters}
					title={options.title}
					headerSubtitle={options.subTitle}
					defaultFormat="pdf" // ou "csv"
				/>
			</ModalMain>
		</div>
	);
};

export default MainRegisterProduct;
